import dayjs from "dayjs";

import { DEFAULT_TIMES } from "@client/context/config";
import getOrderExtras from "@client/helpers/getOrderExtras";
import {
	OrderStatuses,
	Order_MinimalDetails,
	Product,
	VendorDetails,
} from "@client/interfaces/vendor-store.interfaces";

// TODO - move this logic to the backend
export function computeDates(
	order: Order_MinimalDetails,
	vendorDetails: VendorDetails,
	cancellation_reason?: string
) {
	const currentChangeTime = dayjs().toISOString();
	const timebomb_when_accepted =
		vendorDetails?.time.time_pick_order || DEFAULT_TIMES.TO_PICK;

	switch (order.status) {
		case OrderStatuses.Picking:
			if (order.dates?.scheduled_date) break;
			order.dates.changes.accepted = {
				accepted_at: currentChangeTime,
				can_pick_until: dayjs()
					.add(timebomb_when_accepted, "minutes")
					.toISOString(),
				timebomb_when_accepted,
				OrderExtraDetails: getOrderExtras(vendorDetails),
			};
			break;

		case OrderStatuses.Packed:
			order.dates.changes.picking_done_at = currentChangeTime;
			break;

		case OrderStatuses.Shipped:
			order.dates.changes.shipped_at = currentChangeTime;
			break;

		case OrderStatuses.Delivered:
			order.dates.changes.received_by_customer_at = currentChangeTime;
			break;

		case OrderStatuses.Timedout:
			order.dates.changes.cancelled = {
				timedout: {
					at: currentChangeTime,
					OrderExtraDetails: getOrderExtras(vendorDetails),
					timeout_info_extras: {
						can_accept_until: order.dates.received?.can_accept_until,
						can_pick_until: order.dates.changes?.accepted?.can_pick_until,
					},
				},

				cancellation_reason,
			};
			break;

		case OrderStatuses.Rejected:
			order.dates.changes.cancelled = {
				rejected_at: currentChangeTime,
				cancellation_reason,
			};
			break;
	}

	return order.dates;
}

function countFreq(arr: string[], target: string) {
	let res = 0;
	for (let i = 0; i < arr.length; i++) {
		// If the current element is equal to
		// target, increment the result
		if (arr[i] === target) res++;
	}

	return res;
}

export function getProcessedProducts(
	products: Product[],
	rejectedProducts: string[]
) {
	const rejectedProductsIds = rejectedProducts.map((rejectedProduct) =>
		rejectedProduct.slice(0, rejectedProduct.indexOf("-"))
	);
	return products.map((product) => {
		return {
			...product,
			order_details: {
				...product.order_details,
				qtyCanceled: countFreq(rejectedProductsIds, String(product.id)),
			},
		};
	});
}
